/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const XCircleIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75m3.442-11.964a1 1 0 0 0-1.414-1.415l-2.121 2.122L9.786 8.37A1 1 0 0 0 8.37 9.786l2.122 2.12-2.122 2.122a1 1 0 1 0 1.415 1.414l2.12-2.12 2.122 2.12a1 1 0 0 0 1.414-1.414l-2.12-2.121z" clipRule="evenodd" /></svg>;
};
export default XCircleIcon;